import { useNavigate } from "react-router-dom";
import { Bell } from "@phosphor-icons/react";
import { useAuth } from "../contexts/AuthContext";
import { useNotifications } from "../contexts/NotificationsContext";

/**
 * Mobile-header bell icon with an unread-count badge.
 *
 * The count is owned by `NotificationsContext` so the badge here stays
 * perfectly in sync with the sidebar badge and any mutation made on the
 * /notifications page (mark-all-read, dismiss, etc.) — no 30-second wait.
 */
export default function NotificationBell({ testid = "notification-bell" }) {
    const { user } = useAuth();
    const { unreadCount } = useNotifications();
    const navigate = useNavigate();

    if (!user) return null;

    const display = unreadCount >= 99 ? "99+" : unreadCount;

    return (
        <button
            type="button"
            onClick={() => navigate("/notifications")}
            data-testid={testid}
            aria-label={`Notifications${unreadCount > 0 ? ` — ${unreadCount} unread` : ""}`}
            className="relative p-2 rounded-md hover:bg-black/5 dark:hover:bg-white/5"
        >
            <Bell size={20} weight="regular" />
            {unreadCount > 0 && (
                <span
                    data-testid="notification-badge"
                    className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[#FF8A00] text-white text-[10px] font-bold flex items-center justify-center"
                >
                    {display}
                </span>
            )}
        </button>
    );
}
